<template>
  <div id="app" :class="needGray ? 'gray' : ''">
    <NavLay></NavLay>
  </div>
</template>

<script>
import NavLay from '@components/layouts/NavLay.vue'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
export default {
  name: 'App',
  data() {
    return {
      needGray: false
    }
  },
  components: {
    NavLay
  },
  created() {
    // 获取用户的visitorId和ua
    this.getDeviceFingerprint()
    window.document.documentElement.setAttribute('data-theme', this.$store.state.common.Mode)
  },
  watch: {
    '$store.state.common.Mode': {
      handler(val) {
        window.document.documentElement.setAttribute('data-theme', val)
      }
    }
  },
  methods: {
    async getDeviceFingerprint() {
      const fpPromise = await FingerprintJS.load()
      // 调用FingerprintJS.load()返回一个Promise对象，用于加载和初始化FingerprintJS库。
      // 可给FingerprintJS.load()传参{debug: true}开启调试模式
      const result = await fpPromise.get()
      // 调用fpPromise.get()获取访问者指纹信息，并返回一个包含指纹ID和其他信息的结果对象。
      const fingerprintId = result.visitorId
      const userAgent = navigator.userAgent
      this.$storage.setItem('browserId', fingerprintId)
      this.$storage.setItem('userAgent', userAgent)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/theme_handler.scss';
/**
* 重大事件灰度处理
*/
.gray {
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(100%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue